import { useState, useEffect } from "react";
import { getMembers } from "../../utils/api";
import type { MemberCounts } from "@/types/members";

export const useMembers = (refreshTrigger: boolean, role: string | null) => {
  const [membersList, setMembersList] = useState<any[]>([]);
  const [membersCount, setMembersCount] = useState<MemberCounts>({
    active: 0,
    owner: 0,
    teamLead: 0,
    teamMember: 0,
    pending: 0,
    teamCapacity: { max: 0, remaining: 0 },
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMembers = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getMembers();
      const counts = result?.data?.content?.counts || {};
      const members = result?.data?.content?.businessStaff || [];
      setMembersCount(counts);
      setMembersList(members);
    } catch (err: any) {
      setError("Failed to fetch members. Please try again.");
      console.error("Error fetching members:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (role !== "client") {
      fetchMembers();
    }
  }, [refreshTrigger, role]);

  return {
    membersList,
    membersCount,
    setMembersList,
    loading,
    error,
  };
};
